
import WebFont from 'webfontloader'

const options = {"custom":{"families":["futura-pt","futura-pt-bold"],"urls":["https:\u002F\u002Fuse.typekit.net\u002Fhgw4npy.css"]},"timeout":2000}

WebFont.load(options)
